import {
  Row,
  Col,
  Card,
  Radio,
  Button,
  Modal,
  Form,
  Input,
  Badge,
  Descriptions,
  Tag,
  message,
  Image,
  Upload,
  Space,
  Popconfirm,
} from "antd";

import { useEffect, useState } from "react";
import {
  ArrowLeftOutlined,
  CloseCircleFilled,
  DeleteFilled,
  DeleteOutlined,
  InboxOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  addCombinationsAPI,
  addCookingStepsAPI,
  addIngredientsAPI,
  addQuestionAPI,
  addQuestionWithOptionsAPI,
  addRecipeImagesAPI,
  deleteCombinationsAPI,
  deleteIngredientsAPI,
  deleteQuestionAPI,
  deleteQuestionOptionAPI,
  deleteRecipeImagesAPI,
  getCombinationsAPI,
  getCookingStepsAPI,
  getIngredientsAPI,
  getQuestionWithOptionsAPI,
  getRecipeDetailsAPI,
  getRecipeImagesAPI,
  deleteCookingStepsAPI,
  updateCookingStepsAPI,
} from "../api/recipes";

import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import constant from "../config/constant";
function RecipeDetails() {
  const [ingredientsForm] = Form.useForm();
  const [questionForm] = Form.useForm();
  const [imageForm] = Form.useForm();
  const [stepsForm] = Form.useForm();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [questionForUpdate, setQuestionForUpdate] = useState(null);
  const [questionModal, toggleQuestionModal] = useState(false);
  const [questionOptionModal, toggleQuestionOptionModal] = useState(false);
  const [ingredientsModal, toggleingredientsModal] = useState(false);
  const [imageModal, toggleimageModal] = useState(false);
  const [stepsModal, togglestepsModal] = useState(false);
  const [recipe, setRecipe] = useState(null);
  const [recipeImages, setRecipeImages] = useState(null);
  const [ingredients, setIngredients] = useState(null);
  const [cookingSteps, setCookingSteps] = useState(null);
  const [questionsWithOptions, setQuestionWithOptions] = useState(null);
  const [questionCombinations, setQuestionCombinations] = useState([]);
  const [options, setOptions] = useState([{ index: 1, title: "" }]);
  const [mediaURL, setMediaURL] = useState("");
  const [isMediaRemoved, removeMedia] = useState(false);
  const [stepForUpdate, setStepForUpdate] = useState(null);
  useEffect(() => {
    _getRecipeDetails(window.history.state?.usr?.recipe_id);
    _getRecipeImages(window.history.state?.usr?.recipe_id);
    _getIngredients(window.history.state?.usr?.recipe_id);
    _getCookingSteps(window.history.state?.usr?.recipe_id);
    _getQuestionWithOptions(window.history.state?.usr?.recipe_id);
  }, [window.history.state?.usr?.recipe_id]);

  const _getRecipeDetails = async (id) => {
    try {
      const res = await getRecipeDetailsAPI(id);
      setRecipe(res?.data);
    } catch (e) {
      console.log("Error", e);
    }
  };
  const _getRecipeImages = async (id) => {
    try {
      const res = await getRecipeImagesAPI(id);
      setRecipeImages(res?.data);
    } catch (e) {
      console.log("Error", e);
    }
  };
  const _getIngredients = async (id) => {
    try {
      const res = await getIngredientsAPI(id);
      setIngredients(res?.data);
    } catch (e) {
      console.log("Error", e);
    }
  };
  const _getCookingSteps = async (id) => {
    try {
      const res = await getCookingStepsAPI(id);
      if (res?.data) {
        setCookingSteps(res?.data);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };
  const generateCombinations = (
    questions,
    currentIndex = 0,
    currentCombination = {},
    combinations = []
  ) => {
    if (currentIndex === questions.length) {
      currentCombination.time = ""; // Add default value for time
      combinations.push({ ...currentCombination });
      return;
    }
    const currentQuestion = questions[currentIndex];
    currentQuestion.options.forEach((option) => {
      const updatedCombination = { ...currentCombination };
      updatedCombination[currentQuestion.question_id] = {
        id: option.id,
        title: option.title,
      };
      generateCombinations(
        questions,
        currentIndex + 1,
        updatedCombination,
        combinations
      );
    });
    return combinations;
  };
  const _getQuestionWithOptions = async (id) => {
    try {
      const res = await getQuestionWithOptionsAPI(id);
      setQuestionWithOptions(res?.data);
      let questions = res?.data.filter(
        (item) => item.question_title != "temperature"
      );
      const allCombinations = generateCombinations(questions);

      // setQuestionCombinations(allCombinations);
      _getRecipeCombinations(allCombinations, id);
    } catch (e) {
      console.log("Error", e);
    }
  };
  const _getRecipeCombinations = async (allCombinations, id) => {
    console.log(
      "🚀 ~ const_getRecipeCombinations= ~ allCombinations:",
      allCombinations
    );
    try {
      const res = await getCombinationsAPI(id);
      if (res?.data.length > 0 && res?.data.length !== allCombinations.length) {
        _resetCombinations(id);
      } else if (res?.data.length > 0) {
        allCombinations.forEach((obj_a, index) => {
          obj_a.time = res?.data[index].time;
        });
      }

      setQuestionCombinations(allCombinations);
    } catch (e) {
      console.log("Error", e);
    }
  };
  const _resetCombinations = async (id) => {
    try {
      const res = await deleteCombinationsAPI(id);
      if (res) {
        _getQuestionWithOptions(id);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };
  const _toggleQuestionModal = () => {
    toggleQuestionModal(!questionModal);
  };
  const _toggleQuestionOptionModal = (ques) => {
    setQuestionForUpdate(ques);
    toggleQuestionOptionModal(!questionOptionModal);
  };
  const _toggleingredientsModal = () => {
    toggleingredientsModal(!ingredientsModal);
  };
  const _toggleImageModal = () => {
    toggleimageModal(!imageModal);
  };
  const _toggleStepsModal = () => {
    togglestepsModal(!stepsModal);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const _goBack = () => {
    navigate(-1);
  };
  const _addIngredients = async (values) => {
    let payload = {
      recipe_id: recipe?.id,
      ingredient: values?.ingredient,
    };
    try {
      const res = await addIngredientsAPI(payload);
      console.log("res", res);
      if (res) {
        ingredientsForm.setFieldsValue({
          ingredient: "",
        });
        _getIngredients(recipe?.id);
        _toggleingredientsModal();
      }
    } catch (e) {
      console.log("Error", e);
    }
  };

  const _addImages = async (values) => {
    let payload = {
      recipe_id: recipe?.id,
      image_src: mediaURL,
    };
    try {
      const res = await addRecipeImagesAPI(payload);
      console.log("res", res);
      if (res) {
        _toggleImageModal();
        _getRecipeImages(recipe?.id);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };
  const _deleteQuestion = async (id) => {
    try {
      const res = await deleteQuestionAPI(id);
      if (res) {
        _getQuestionWithOptions(recipe?.id);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };
  const _deleteOption = async (id) => {
    try {
      const res = await deleteQuestionOptionAPI(id);

      if (res) {
        _getQuestionWithOptions(recipe?.id);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };
  const _deleteIngredients = async (ing) => {
    const res = await deleteIngredientsAPI(ing?.id);
    if (res.statusCode === constant.RESPONSE_CODE.SUCCESS) {
      _getIngredients(recipe?.id);
    }
  };

  const _addQuestions = async (values) => {
    let payload = {
      recipe_id: recipe?.id,
      title: values?.title,
    };
    try {
      const res = await addQuestionAPI(payload);
      console.log("addQuestionAPI", res);
      if (res) {
        toggleQuestionModal();
        _getQuestionWithOptions(recipe?.id);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };
  const _addQuestionOptions = async (values) => {
    console.log("questionForUpdate", questionForUpdate);
    let payload;
    if (questionForUpdate?.question_title === "temperature") {
      payload = {
        title: values?.option,
        question_id: questionForUpdate?.question_id,
        meta_data: {
          temp: values?.temp,
        },
      };
    } else {
      payload = {
        title: values?.option,
        question_id: questionForUpdate?.question_id,
      };
    }

    try {
      const res = await addQuestionWithOptionsAPI(payload);
      if (res) {
        toggleQuestionOptionModal();
        _getQuestionWithOptions(recipe?.id);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };
  const removeImageAndMediaURl = () => {
    removeMedia(false);
    setMediaURL("");
  };
  const uploadMedia = {
    name: "image",
    action: constant.API_URL.DEV + "images/upload",
    multiple: false,
    method: "post",
    listType: "picture",
    maxCount: 1,
    data: {
      imgCategory: "recipe",
    },
    headers: {
      authorization: "Bearer " + localStorage.getItem("token"),
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        console.log(
          "🚀 ~ file: Category.js:123 ~ onChange ~ info?.file?.response:",
          info?.file?.response
        );
        // setMediaURL(info?.file?.response?.response?.uploadUrl);
        setMediaURL(info?.file?.response?.data?.image_src);
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  const _deleteImage = async (item) => {
    try {
      const res = await deleteRecipeImagesAPI(item?.id);
      if (res) {
        _getRecipeImages(window.history.state?.usr?.recipe_id);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };
  const _saveCombo = async () => {
    const formattedCombos = questionCombinations.map((combination) => ({
      recipe_id: recipe?.id, // Assuming recipe is accessible in the component scope
      time: combination.time,
      options: Object.entries(combination).reduce((acc, [key, value]) => {
        if (key !== "time") {
          acc[key] = value.id;
        }
        return acc;
      }, {}),
    }));
    console.log("Formatted combinations:", formattedCombos);
    try {
      const res = await addCombinationsAPI(formattedCombos);
      console.log("🚀 ~ const_saveCombo= ~ res:", res);
      if (res) {
      }
    } catch (e) {
      console.log("Error", e);
    }

    // You can perform further actions like sending this formattedCombos array to an API endpoint for saving
  };
  const handleChangeTime = (index, value) => {
    let parsedValue;
    if (value === "") {
      parsedValue = 0; // Set to 0 if the input value is empty
    } else {
      parsedValue = parseFloat(value); // Parse input value to a float
    }

    const updatedCombinations = [...questionCombinations];
    updatedCombinations[index].time = parsedValue; // Update the time value
    setQuestionCombinations(updatedCombinations);
  };
  console.log("questionsWithOptions", questionsWithOptions);
  const _addSteps = async (values) => {
    try {
      const payload = {
        recipe_id: recipe?.id,
        step: values.step,
        title: values.title,
        description: values.description,
        image_src: mediaURL,
        video_url: values.video_url || "",
      };

      const res = await addCookingStepsAPI(payload);
      if (res?.statusCode === constant.RESPONSE_CODE.SUCCESS) {
        // Reset form
        stepsForm.resetFields();

        // Reset media URL
        setMediaURL("");

        // Reset media removed state if you're using it
        removeMedia(false);

        // Close modal
        togglestepsModal(false);

        // Refresh cooking steps list
        _getCookingSteps(recipe?.id);

        // Show success message (optional)
        message.success("Step added successfully");
      }
    } catch (e) {
      console.log("Error", e);
      message.error("Failed to add step");
    }
  };
  const _deleteStep = async (stepId) => {
    try {
      const res = await deleteCookingStepsAPI(stepId);
      await _getCookingSteps(recipe?.id);
    } catch (e) {
      console.log("Error", e);
      message.error("Failed to delete step");
    }
  };

  const _editStep = (step) => {
    stepsForm.setFieldsValue({
      step: step.step,
      title: step.title,
      description: step.description,
      video_url: step.video_url,
    });
    setMediaURL(step.image_src || "");
    setStepForUpdate(step.id);
    togglestepsModal(true);
  };
  return (
    <>
      <div className="tabled">
        <div
          style={{ paddingTop: 10, paddingBottom: 10, cursor: "pointer" }}
          onClick={_goBack}
        >
          <ArrowLeftOutlined /> Back
        </div>

        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={recipe?.name}
              extra={
                <>
                  <Radio.Group>
                    <Radio.Button value="a" onClick={_toggleingredientsModal}>
                      <PlusOutlined />
                      <span style={{ marginLeft: 10 }}>Add Ingredients</span>
                    </Radio.Button>
                    <Radio.Button value="b" onClick={_toggleStepsModal}>
                      <PlusOutlined />
                      <span style={{ marginLeft: 10 }}>Add Steps</span>
                    </Radio.Button>
                    <Radio.Button value="c" onClick={_toggleImageModal}>
                      <PlusOutlined />
                      <span style={{ marginLeft: 10 }}>Add Images</span>
                    </Radio.Button>
                    <Radio.Button value="d" onClick={_toggleQuestionModal}>
                      <PlusOutlined />
                      <span style={{ marginLeft: 10 }}>Add Questions</span>
                    </Radio.Button>
                    z
                  </Radio.Group>
                </>
              }
            >
              <div className="ant-list-box m-25 px-2">
                <Descriptions
                  bordered
                  items={[
                    {
                      key: "1",
                      label: "ID",
                      children: recipe?.id,
                    },
                    {
                      key: "2",
                      label: "Name",
                      children: recipe?.name,
                    },

                    {
                      key: "3",
                      label: "Cooking Time",
                      children: recipe?.cooking_time,
                    },
                    {
                      key: "4",
                      label: "Category",
                      children: recipe?.category_id,
                    },
                    {
                      key: "5",
                      label: "Cooking Time",
                      children: recipe?.cooking_time,
                    },
                    {
                      key: "6",
                      label: "Created At",
                      children: moment(recipe?.createdAt).format("lll"),
                      span: 1,
                    },
                    {
                      key: "7",
                      label: "Status",
                      children: <Badge status="processing" text="Active" />,
                      span: 3,
                    },
                    {
                      key: "8",
                      label: "Description",
                      span: 3,
                      children: (
                        <div style={{ whiteSpace: "initial" }}>
                          {recipe?.description}
                        </div>
                      ),
                    },
                    {
                      key: "9",
                      label: "Ingredients",
                      span: 1,
                      children: (
                        <>
                          {ingredients &&
                            ingredients.map((ing, index) => {
                              return (
                                <p key={index}>
                                  <Tag color="blue">{ing?.ingredient}</Tag>
                                </p>
                              );
                            })}
                        </>
                      ),
                    },
                    {
                      key: "10",
                      label: "Images",
                      span: 3,
                      children: (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            flexWrap: "wrap",
                          }}
                        >
                          {recipeImages && recipeImages.length > 0 ? (
                            recipeImages.map((img, index) => (
                              <div key={index} style={{ position: "relative" }}>
                                <Image
                                  src={img.image_src}
                                  width={200}
                                  style={{ objectFit: "cover" }}
                                />
                                <DeleteOutlined
                                  style={{
                                    position: "absolute",
                                    top: 5,
                                    right: 5,
                                    fontSize: 20,
                                    color: "#cf1322",
                                    cursor: "pointer",
                                    background: "white",
                                    borderRadius: "50%",
                                    padding: "5px",
                                  }}
                                  onClick={() => _deleteImage(img)}
                                />
                              </div>
                            ))
                          ) : (
                            <span>No images available</span>
                          )}
                        </div>
                      ),
                    },
                    {
                      key: "11",
                      label: "Cooking Steps",
                      span: 3,
                      children: (
                        <div className="ant-list-box table-responsive">
                          <table className="width-100">
                            <thead>
                              <tr>
                                <th>Step</th>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Image</th>
                                <th>Video URL</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {cookingSteps && cookingSteps.length > 0 ? (
                                cookingSteps.map((step, index) => (
                                  <tr key={index}>
                                    <td style={{ textAlign: "center" }}>
                                      {step.step}
                                    </td>
                                    <td>{step.title}</td>
                                    <td
                                      style={{
                                        maxWidth: "300px",
                                        whiteSpace: "pre-wrap",
                                      }}
                                    >
                                      {step.description}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {step.image_src && (
                                        <Image
                                          src={step.image_src}
                                          width={100}
                                          style={{ objectFit: "cover" }}
                                        />
                                      )}
                                    </td>
                                    <td>
                                      {step.video_url && (
                                        <a
                                          href={step.video_url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          Watch Video
                                        </a>
                                      )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <Button
                                        type="primary"
                                        danger
                                        icon={<DeleteOutlined />}
                                        onClick={() => _deleteStep(step.id)}
                                      >
                                        Delete
                                      </Button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={6}
                                    style={{ textAlign: "center" }}
                                  >
                                    No cooking steps available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      ),
                    },
                    {
                      key: "12",
                      label: "Questions",
                      children: (
                        <Space
                          direction="vertical"
                          size="middle"
                          style={{
                            display: "flex",
                          }}
                        >
                          {questionsWithOptions &&
                            questionsWithOptions.map((ques, index) => {
                              return (
                                <div
                                  className="ant-list-box table-responsive"
                                  key={index}
                                >
                                  <table>
                                    <thead>
                                      <tr>
                                        <th>
                                          {index +
                                            1 +
                                            ". " +
                                            ques?.question_title}
                                        </th>
                                        <th>
                                          {ques?.question_title !==
                                          "temperature" ? (
                                            <Button
                                              onClick={() =>
                                                _toggleQuestionOptionModal(ques)
                                              }
                                            >
                                              Add Options
                                            </Button>
                                          ) : null}
                                          {ques?.question_title ===
                                          "temperature" ? (
                                            <Button
                                              style={{ marginLeft: 10 }}
                                              onClick={() =>
                                                _toggleQuestionOptionModal(ques)
                                              }
                                            >
                                              Add Temperature
                                            </Button>
                                          ) : null}
                                          <Button
                                            style={{ marginLeft: 10 }}
                                            onClick={() =>
                                              _deleteQuestion(ques?.question_id)
                                            }
                                            danger
                                          >
                                            Delete Question
                                          </Button>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {ques.options.length > 0 &&
                                        ques?.options.map((opt, index2) => {
                                          return (
                                            <tr
                                              style={{ marginLeft: 10 }}
                                              key={index2}
                                            >
                                              <td>
                                                {opt?.title}{" "}
                                                {opt?.meta_data
                                                  ? "( " +
                                                    opt?.meta_data?.temp +
                                                    "°F )"
                                                  : ""}
                                              </td>
                                              <td>
                                                {opt?.id ? (
                                                  <DeleteFilled
                                                    style={{
                                                      color: "#BB2124",
                                                      fontSize: "16px",
                                                    }}
                                                    onClick={() =>
                                                      _deleteOption(opt?.id)
                                                    }
                                                  />
                                                ) : null}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                    </tbody>
                                  </table>
                                </div>
                              );
                            })}
                        </Space>
                      ),
                      span: 3,
                    },
                    {
                      key: "13",
                      label: "Combinations",
                      children: (
                        <Space
                          direction="vertical"
                          size="middle"
                          style={{
                            display: "flex",
                          }}
                        >
                          {questionCombinations &&
                          questionCombinations.length > 0 ? (
                            <div className="ant-list-box table-responsive m-25">
                              <table className="width-100">
                                <thead>
                                  <tr>
                                    {questionsWithOptions &&
                                      questionsWithOptions
                                        .filter(
                                          (item) =>
                                            item.question_title != "temperature"
                                        )
                                        .map((qt, index) => {
                                          return (
                                            <th key={index}>
                                              <div className="text-left">
                                                {qt?.question_title}
                                              </div>
                                            </th>
                                          );
                                        })}

                                    <th>
                                      <div className="text-center">
                                        Time(in mins)
                                      </div>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {questionCombinations &&
                                    questionCombinations.length > 0 &&
                                    questionCombinations.map(
                                      (combination, index) => (
                                        <tr key={index}>
                                          {questionsWithOptions
                                            .filter(
                                              (item) =>
                                                item.question_title !=
                                                "temperature"
                                            )
                                            .map((question) => (
                                              <td key={question?.question_id}>
                                                {
                                                  combination[
                                                    question?.question_id
                                                  ]?.title
                                                }
                                              </td>
                                            ))}
                                          <td>
                                            <Input
                                              name="Time"
                                              value={combination?.time}
                                              onChange={(e) =>
                                                handleChangeTime(
                                                  index,
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td>
                                      <Button
                                        type="primary"
                                        onClick={_saveCombo}
                                      >
                                        Save Combinations
                                      </Button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            "NA"
                          )}
                        </Space>
                      ),
                      span: 3,
                    },
                  ]}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {/* Question Modal Start*/}
      <Modal
        title="Add Question"
        open={questionModal}
        okCancel={false}
        onCancel={_toggleQuestionModal}
        footer={null}
      >
        <Form
          name="basic"
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 20,
          }}
          style={{
            maxWidth: 600,
          }}
          onFinish={_addQuestions}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          questionForm={questionForm}
        >
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                wrapperCol={{
                  span: 20,
                }}
                label="title"
                name="title"
                rules={[
                  {
                    required: true,
                    message: "Please enter question title!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={12}></Col>
            <Col span={12}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                wrapperCol={{
                  span: 16,
                }}
              >
                <Button type="primary" block htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      {/* Question Modal End*/}
      {/* Question Options Start*/}
      <Modal
        title="Add Options"
        open={questionOptionModal}
        okCancel={false}
        onCancel={_toggleQuestionOptionModal}
        footer={null}
      >
        <Form
          name="basic"
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 20,
          }}
          style={{
            maxWidth: 600,
          }}
          onFinish={_addQuestionOptions}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          questionForm={questionForm}
        >
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 18,
                }}
                label="Question title"
              >
                {questionForUpdate?.question_title}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                labelCol={{
                  span: 12,
                }}
                wrapperCol={{
                  span: 14,
                }}
                label={"Option"}
                name={"option"}
                rules={[
                  {
                    required: true,
                    message: "enter option",
                  },
                ]}
              >
                <span>
                  <Input />
                </span>
              </Form.Item>
              {questionForUpdate?.question_title === "temperature" ? (
                <Form.Item
                  labelCol={{
                    span: 12,
                  }}
                  wrapperCol={{
                    span: 14,
                  }}
                  label={"Temprature"}
                  name={"temp"}
                  rules={[
                    {
                      required: true,
                      message: "enter option",
                    },
                  ]}
                >
                  <span>
                    <Input />
                  </span>
                </Form.Item>
              ) : null}
            </Col>
            <Col span={12}>
              <Form.Item
                wrapperCol={{
                  span: 8,
                }}
              ></Form.Item>
            </Col>
            <Col span={12}></Col>
            <Col span={12}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                wrapperCol={{
                  span: 16,
                }}
              >
                <Button type="primary" block htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      {/* Question Options End*/}
      {/* ingredientsModal Modal Start*/}
      <Modal
        title="Add Ingredients"
        open={ingredientsModal}
        okCancel={false}
        onCancel={_toggleingredientsModal}
        footer={null}
      >
        <Form
          name="basic"
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 20,
          }}
          style={{
            maxWidth: 600,
          }}
          onFinish={_addIngredients}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          form={ingredientsForm}
        >
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 18,
                }}
                label="Ingredients"
                name="ingredient"
                rules={[
                  {
                    required: true,
                    message: "Please enter ingredients!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}></Col>
            <Col span={12}>
              <Form.Item
                labelCol={{
                  span: 4,
                }}
                wrapperCol={{
                  span: 16,
                }}
              >
                <Button type="primary" block htmlType="submit">
                  Save
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      {/* ingredientsModal Modal End*/}
      {/* images Modal Start*/}
      <Modal
        title="Add Images"
        open={imageModal}
        okCancel={false}
        onCancel={_toggleImageModal}
        footer={null}
      >
        <Form
          name="basic"
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 20,
          }}
          style={{
            maxWidth: 600,
          }}
          onFinish={_addImages}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          form={imageForm}
        >
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name="dragger"
                noStyle
                rules={
                  isMediaRemoved
                    ? []
                    : [
                        {
                          required: true,
                          message: "Please upload recipe image!",
                        },
                      ]
                }
              >
                {isMediaRemoved ? (
                  <div>
                    <Image width={400} src={mediaURL} />
                    <DeleteOutlined
                      style={{
                        fontSize: 30,
                        color: "#cf1322",
                        marginLeft: 20,
                      }}
                      onClick={removeImageAndMediaURl}
                    />
                  </div>
                ) : (
                  <Upload.Dragger
                    {...uploadMedia}
                    style={{
                      maxHeight: 150,
                    }}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      Click or drag file to this area to upload
                    </p>
                  </Upload.Dragger>
                )}
              </Form.Item>
              <div style={{ marginTop: 10 }}>
                <Button type="primary" block htmlType="submit">
                  Save Image
                </Button>
              </div>
            </Col>
          </Row>
          <Row gutter={24}></Row>
        </Form>
      </Modal>
      {/* images Modal End*/}
      <Modal
        title="Add Cooking Steps"
        open={stepsModal}
        okCancel={false}
        onCancel={_toggleStepsModal}
        footer={null}
      >
        <Form
          name="steps"
          form={stepsForm}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          onFinish={_addSteps}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Step Number"
            name="step"
            rules={[{ required: true, message: "Please enter step number!" }]}
          >
            <Input type="number" min={1} />
          </Form.Item>

          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: "Please enter step title!" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Description"
            name="description"
            rules={[
              { required: true, message: "Please enter step description!" },
            ]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>

          <Form.Item label="Video URL" name="video_url">
            <Input />
          </Form.Item>

          <Form.Item label="Image" name="image">
            <Upload.Dragger
              {...uploadMedia}
              style={{
                maxHeight: 150,
              }}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </Upload.Dragger>
          </Form.Item>

          {mediaURL && (
            <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
              <Image width={200} src={mediaURL} />
              <DeleteOutlined
                style={{
                  fontSize: 20,
                  color: "#cf1322",
                  marginLeft: 10,
                  cursor: "pointer",
                }}
                onClick={() => setMediaURL("")}
              />
            </Form.Item>
          )}

          <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
            <Button type="primary" htmlType="submit" block>
              Add Step
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default RecipeDetails;
